export default {"src":"/_next/static/media/carPlayground3LightBg_104.8fa63d4f.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};